<template>
  <LayoutPrimary>
    <router-view :key="$route.fullPath" />
  </LayoutPrimary>
</template>

<script>
  import LayoutPrimary from '@modules/v2/layout/layout-primary'

  export default {
    name: 'TeamupRootView',
    components: {
      LayoutPrimary,
    },
  };
</script>
